import gql from 'graphql-tag';
import { convertFilterRequestUrl } from '../../utils/utils';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter
    ? `, filter: ${convertFilterRequestUrl(filter, [
        'type',
        'recognitionType',
        'offsetAccount',
        'reportObjectType',
        'transactionType',
        'itemType',
      ])}`
    : '';
  const getRevenueSummaryReport = `getRevenueSummaryReport(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${getRevenueSummaryReport} {
        productCompany
        glAccount
        productFamily
        productLine
        productType
        productSubType
        itemName
        recognizedRevenue
        remainingRevenue
        totalRevenue
        type
        recognitionType
      }
    }
  `;
};
